import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeedbackResponse } from 'app/services/edpApiV1/consultations';
import { RootState } from 'app/store';
import { isSameFormValues } from 'shared/helpers/utils';
import { TSingleConsultationPreparedData } from 'shared/types/consultations.types';
import { TFormAdditionally } from 'shared/types/types';

type TReason = { id?: number | undefined; violatorId?: number | undefined; name?: string | undefined };

type TInitialValuesFilter = {
  isClaim: boolean | null;
  subtopicId: number | null;
  violationId: number | null;
  isJustified: boolean | null;
  violationReasonId: number | null;
  violationReasons: TReason[] | null;
  asInitFormvals: boolean;
  isSaveBtnVisible: boolean;
  feedback?: FeedbackResponse | null;
};

const initialState: TInitialValuesFilter = {
  isClaim: null,
  subtopicId: null,
  violationId: null,
  isJustified: null,
  violationReasonId: null,
  violationReasons: null,
  asInitFormvals: false,
  isSaveBtnVisible: false,
};

export const consultationsSlice = createSlice({
  name: 'ui/consultations',
  initialState,
  reducers: {
    isClaim(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isClaim: payload };
    },
    subtopicId(state, { payload }: PayloadAction<number>) {
      return { ...state, subtopicId: payload };
    },
    violationId(state, { payload }: PayloadAction<number>) {
      return { ...state, violationId: payload };
    },
    isJustified(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isJustified: payload };
    },
    violationReasonId(state, { payload }: PayloadAction<number>) {
      return { ...state, violationReasonId: payload };
    },
    violationReasons(state, { payload }: PayloadAction<TReason[]>) {
      return {
        ...state,
        violationReasons: payload,
      };
    },
    resetFieldsByName(state, { payload }: PayloadAction<string[]>) {
      const cleanedFields: Record<string, null> = {};
      payload.forEach(fieldName => (cleanedFields[fieldName] = null));
      return {
        ...state,
        ...cleanedFields,
      };
    },
    checkInitVals(
      state,
      {
        payload,
      }: PayloadAction<{
        saved: TSingleConsultationPreparedData;
        form: TFormAdditionally;
      }>,
    ) {
      const savedData = payload.saved;
      const formData = payload.form;
      return {
        ...state,
        asInitFormvals: isSameFormValues(savedData, formData, savedData?.isClaim),
      };
    },
    feedback(state, { payload }: PayloadAction<FeedbackResponse>) {
      return { ...state, feedback: payload };
    },
    clearValues() {
      return initialState;
    },
    isSaveBtnVisible(state, { payload }: PayloadAction<boolean>) {
      return { ...state, isSaveBtnVisible: payload };
    },
  },
});

const selectConsultations = (state: RootState) => state.ui.consultations;

export const selectors = { selectConsultations };
export const actions = consultationsSlice.actions;
export const reducer = consultationsSlice.reducer;
